export const CLEAR_SUGGESTEDPF = 'CLEAR_SUGGESTEDPF';
export const CLEAR_STATE = 'CLEAR_STATE';

export const DELETE_SUGGESTEDPF = 'DELETE_SUGGESTEDPF';
export const DELETE_SUGGESTEDPF_ERROR = 'DELETE_SUGGESTEDPF_ERROR';
export const DELETE_SUGGESTEDPF_SUCCESS = 'DELETE_SUGGESTEDPF_SUCCESS';

export const GET_SUGGESTEDPF_BY_DATE = 'GET_SUGGESTEDPF_BY_DATE';
export const GET_SUGGESTEDPF_BY_DATE_ERROR = 'GET_SUGGESTEDPF_BY_DATE_ERROR';
export const GET_SUGGESTEDPF_BY_DATE_SUCCESS = 'GET_SUGGESTEDPF_BY_DATE_SUCCESS';

export const SAVE_SUGGESTEDPF = 'SAVE_SUGGESTEDPF';
export const SAVE_SUGGESTEDPF_ERROR = 'SAVE_SUGGESTEDPF_ERROR';
export const SAVE_SUGGESTEDPF_SUCCESS = 'SAVE_SUGGESTEDPF_SUCCESS';

export const GET_TRANSACTION_PF = 'GET_TRANSACTION_PF';
export const GET_TRANSACTION_PF_ERROR = 'GET_TRANSACTION_PF_ERROR';
export const GET_TRANSACTION_PF_SUCCESS = 'GET_TRANSACTION_PF_SUCCESS';

export const GET_SUGGESTED_PF = 'GET_SUGGESTED_PF';
export const GET_SUGGESTED_PF_ERROR = 'GET_SUGGESTED_PF_ERROR';
export const GET_SUGGESTED_PF_SUCCESS = 'GET_SUGGESTED_PF_SUCCESS';



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/SuggestedPF/constants.js